function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 0h7l6 6v15c0 1.66-1.34 3-3 3H7c-1.66 0-3-1.34-3-3V3c0-1.66 1.34-3 3-3",
  style: {
    fill: "#1d252d",
    fillRule: "evenodd",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 0v4c0 1.1.9 2 2 2h4z",
  style: {
    strokeWidth: 0,
    fill: "#fff",
    isolation: "isolate",
    opacity: 0.6
  }
}));
export default SvgDefault;